import type { PIIString } from './privacy';

function convertToPIIString(str: string): PIIString;
function convertToPIIString(str: string | null): PIIString | null;
function convertToPIIString(str?: string): PIIString | undefined;
function convertToPIIString(str?: string | null): PIIString | null | undefined;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type -- overloads above provide explicit return types; adding one here breaks downstream type inference
function convertToPIIString(str?: string | null) {
  if (str === undefined || str === null) {
    return str;
  }
  // oxlint-disable-next-line @trello/no-restricted-syntax
  return str as unknown as PIIString;
}

export { convertToPIIString };
